import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Material Data AI Icon Component
 *
 * An AI/brain icon for the Materiom AI feature.
 */
const RobotIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 46.164 63.702">
      <defs>
        <clipPath id="clip-path-ai">
          <rect
            id="Rectangle_1401"
            width="54.94"
            height="49.377"
            fill="#609690"
          />
        </clipPath>
      </defs>
      <g id="GEN_ai_icon" transform="translate(-373.841 -39.255)">
        <rect
          id="Rectangle_2689"
          width="35.957"
          height="29.426"
          rx="11"
          transform="translate(379.073 57.408)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <ellipse
          id="Ellipse_157"
          cx="2.57"
          cy="2.597"
          rx="2.57"
          ry="2.597"
          transform="translate(386.708 66.926)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_4728"
          d="M292.012,234.715a2.571,2.571,0,1,1-2.57-2.6A2.584,2.584,0,0,1,292.012,234.715Z"
          transform="translate(115.383 -165.192)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line
          id="Line_1807"
          x2="7.971"
          transform="translate(393.067 78.273)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_4729"
          d="M346.318,239.565c2.112,0,3.823-2.833,3.823-6.328s-1.711-6.327-3.823-6.327"
          transform="translate(68.864 -161.116)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_4730"
          d="M246.672,170.873c0-2.133-2.8-3.862-6.263-3.862s-6.264,1.729-6.264,3.862"
          transform="translate(156.643 -114.243)"
          fill="#96c8c2"
          stroke="#707070"
          strokeWidth="2"
        />
        <path
          id="Path_4731"
          d="M246.672,170.873c0-2.133-2.8-3.862-6.263-3.862s-6.264,1.729-6.264,3.862"
          transform="translate(156.643 -114.243)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_4732"
          d="M164.638,226.91c-2.112,0-3.823,2.833-3.823,6.328s1.711,6.327,3.823,6.327"
          transform="translate(214.026 -161.116)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line
          id="Line_1808"
          y1="8.679"
          x2="3.986"
          transform="translate(397.051 44.088)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line
          id="Line_1809"
          x1="3.675"
          y1="8.002"
          transform="translate(393.376 44.765)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line
          id="Line_1810"
          y1="4.612"
          transform="translate(387.507 87.102)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line
          id="Line_1811"
          y2="4.612"
          transform="translate(406.595 87.102)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_4733"
          d="M204.8,356.346H164.231a1.514,1.514,0,0,1-1.514-1.514v-7.214a1.514,1.514,0,0,1,1.514-1.514H204.8a1.514,1.514,0,0,1,1.514,1.514v7.214a1.514,1.514,0,0,1-1.514,1.514"
          transform="translate(212.537 -254.389)"
          fill="#96c8c2"
        />
        <rect
          id="Rectangle_2690"
          width="43.594"
          height="10.242"
          rx="5.121"
          transform="translate(375.254 91.715)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_4734"
          d="M230.177,111.861a2.365,2.365,0,1,0,2.365-2.389,2.377,2.377,0,0,0-2.365,2.389"
          transform="translate(159.748 -69.217)"
          fill="#96c8c2"
          stroke="#707070"
          strokeWidth="2"
        />
        <ellipse
          id="Ellipse_158"
          cx="2.365"
          cy="2.389"
          rx="2.365"
          ry="2.389"
          transform="translate(389.925 40.255)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_4735"
          d="M278.7,111.861a2.365,2.365,0,1,1-2.365-2.389,2.377,2.377,0,0,1,2.365,2.389"
          transform="translate(125.48 -69.217)"
          fill="#96c8c2"
          stroke="#707070"
          strokeWidth="2"
        />
        <ellipse
          id="Ellipse_159"
          cx="2.365"
          cy="2.389"
          rx="2.365"
          ry="2.389"
          transform="translate(399.448 40.255)"
          fill="none"
          stroke="#4d827b"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </SvgIcon>
  );
};

export default RobotIcon;
